// //test

// export const environment = {
//   production: false,
//  // urlService: 'http://52.55.216.103/rentastesting/api/',
//   //urlCidi:'http://52.55.216.103/api.cidisigemyt/api/cidi/logueoCiDi',
//   urlCidi:` https://www.sigemyt.com/apicidisigemyt/api/cidi/logueoCiDi`,
//   //urlCidi:'http://localhost:16638/api/cidi/logueoCiDi',
//   urlService:'https://environment.sigemyt.com/RentasTesting/api/',
//  // urlReporte: 'http://52.55.216.103/ReportestestingAPI/api/INGRESOS/',
//   urlReporte:'https://environment.sigemyt.com/ReportestestingAPI/api/INGRESOS/',
//   urlPagos360: 'https://environment.sigemyt.com/cajaAPI/api/pagos360/',
//   urlProveedores:'https://ambiente.sigemyt.com/proveedoresemisioneswebapi/api/Proveedor/',
//   codigoJur: 2389,
//  //https://www.sigemyt.com/emisiondeudaemb/app/views/Inmuebles/Inmuebles.html
//  // urlportal: 'http://52.55.216.103/portaltesting/#!/login',
//     urlportal:'https://environment.sigemyt.com/portaltesting/#!/login',
//   urlddjj:'https://environment.sigemyt.com/ingresostesting/inicio.aspx',//www.sigemyt.com/ingresosmlc//ComercioeIndustria/DeclaWeb.aspx/getCuenta
//  // urlddjj:'www.sigemyt.com/ingresosmlc//ComercioeIndustria/DeclaWeb.aspx',
//   urlUsuario:'https://ambiente.sigemyt.com/apiUsuario/api/GetUsuario',
//   urlToken:'https://localhost:44319/api/GetUsuario',
//   tokenUrl:'',
//   urlGeneral: 'https://ambiente.sigemyt.com/'
//  //urlddjj:'https://www.sigemyt.com/ingresosmlc/Inicio.aspx'

// };

//prod

export const environment = {
  production: false,
 // urlService: 'http://52.55.216.103/rentastesting/api/',
  //urlCidi:'http://52.55.216.103/api.cidisigemyt/api/cidi/logueoCiDi',
  urlCidi:` https://www.sigemyt.com/apicidisigemyt/api/cidi/logueoCiDi`,
  //urlCidi:'http://localhost:16638/api/cidi/logueoCiDi',
  urlService:'https://www.sigemyt.com/emisiondeudamlcapi/api/',
 // urlReporte: 'http://52.55.216.103/ReportestestingAPI/api/INGRESOS/',
  urlReporte:'https://www.sigemyt.com/reportesapi/api/INGRESOS/',
  urlPagos360: 'https://www.sigemyt.com/cajaAPI/api/pagos360/',
  urlProveedores:'https://ambiente.sigemyt.com/proveedoresemisioneswebapi/api/Proveedor/',
  codigoJur: 2454,
 //https://www.sigemyt.com/emisiondeudaemb/app/views/Inmuebles/Inmuebles.html
 // urlportal: 'http://52.55.216.103/portaltesting/#!/login',
    urlportal:'https://www.sigemyt.com/mlc/#!/login',
  urlddjj:'https://www.sigemyt.com/ingresos/Inicio.aspx',//www.sigemyt.com/ingresosmlc//ComercioeIndustria/DeclaWeb.aspx/getCuenta
 // urlddjj:'www.sigemyt.com/ingresosmlc//ComercioeIndustria/DeclaWeb.aspx',
  //urlUsuario:'https://ambiente.sigemyt.com/apiUsuario/api/GetUsuario',
  urlUsuario:'https://www.sigemyt.com/apiUsuario/api/GetUsuario',
  urlToken:'https://localhost:44319/api/GetUsuario',
  tokenUrl:'',
  urlGeneral: 'https://ambiente.sigemyt.com/'
 //urlddjj:'https://www.sigemyt.com/ingresosmlc/Inicio.aspx'

};
